import { defineMessages } from "react-intl";
const messages = defineMessages({
    communitySettingsTitle: {
        id: "app.communitySettings.title.text",
        defaultMessage: "Settings",
    },
    communitySettingsDetailsTabTitle: {
        id: "app.communitySettings.details.tabTitle.text",
        defaultMessage: "Details",
    },
    communitySettingsWidgetsTabTitle: {
        id: "app.communitySettings.widgets.tabTitle.text",
        defaultMessage: "Widgets",
    },
    communitySettingsChatbotTabTitle: {
        id: "app.communitySettings.chatbot.tabTitle.text",
        defaultMessage: "Chatbot",
    },
    communitySettingsDxTabTitle: {
        id: "app.communitySettings.dx.tabTitle.text",
        defaultMessage: "Data Exchange",
    },
    communitySettingsAutoscanTabTitle: {
        id: "app.communitySettings.autoscan.tabTitle.text",
        defaultMessage: "AutoScan",
    },
    communitySettingsRegionalLeasingTabTitle: {
        id: "app.communitySettings.regionalLeasing.tabTitle.text",
        defaultMessage: "Similar Spaces",
    },
});
export default messages;
